import { createContext, useContext, useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const SmallContext = /*#__PURE__*/createContext(undefined);
export const SmallContextProvider = ({
  abstractTextElementStyleOverrides,
  children
}) => {
  const value = useMemo(() => ({
    abstractTextElementStyleOverrides
  }), [abstractTextElementStyleOverrides]);
  return /*#__PURE__*/_jsx(SmallContext.Provider, {
    value: value,
    children: children
  });
};

/**
 * Provides the context for the `Small` component.
 * Note: The context is only available when the `Small` component is rendered as an ancestor.
 * @returns SmallContext - The context for the `Small` component.
 * @returns SmallContext.abstractTextElementStyleOverrides - Style overrides to be applied to the `AbstractTextElement` component.
 */
export const useSmallContext = () => {
  const smallContext = useContext(SmallContext);
  return smallContext;
};